import React from 'react';
import {Image, StyleSheet, TouchableOpacity, View} from 'react-native';

import GiftCardProductImage from '../images/brand/giftCardsShop/product-image.png';
import useAppNavigation from '../navigation/useAppNavigation';
import {useStores} from '../stores/use-stores';
import theme from '../style/theme';

import Text from './ui-controls/Text';
import HorizontalTile from './TileAbbreviatedHorizontal';

const TileContent = () => (
  <View>
    <Text style={styles.title}>Gift Cards</Text>
    <Text style={styles.description}>
      The perfect gift to take the guess work out of finding something they
      enjoy. What a great way to celebrate a special occasion or just to say
      thanks. Sent by email for fast, easy delivery.
    </Text>
  </View>
);

const GiftCardTileAbbreviatedHorizontal = () => {
  const {promotionsStore} = useStores();
  const navigation = useAppNavigation();

  const handlePress = () =>
    promotionsStore.navigateToGiftCardsPromotionOrLoadingScreen(
      navigation.navigate,
    );

  return (
    <HorizontalTile
      content={<TileContent />}
      imageSource={GiftCardProductImage}
      onPress={handlePress}
      testID="gift-card-search-result-tile"
    />
  );
};

/**
 * for when vertical tile needed
 */
const GiftCardTileAbbreviatedVertical = () => {
  const {promotionsStore} = useStores();
  const navigation = useAppNavigation();

  const handlePress = () =>
    promotionsStore.navigateToGiftCardsPromotionOrLoadingScreen(
      navigation.navigate,
    );

  return (
    <TouchableOpacity
      onPress={handlePress}
      testID="gift-card-search-result-tile"
      style={{
        flex: 1,
        padding: 8,
        alignItems: 'center',
        borderRadius: 4,
        borderWidth: 0.5,
        borderColor: '#CCC',
        backgroundColor: 'white',
        elevation: 7,
        marginHorizontal: 0,
        marginBottom: 0,
        width: '100%',
      }}>
      <View style={{height: 120}}>
        <Image
          source={GiftCardProductImage}
          style={{height: 80, width: 140, aspectRatio: 1.4}}
        />
      </View>
      <TileContent />
    </TouchableOpacity>
  );
};

export default GiftCardTileAbbreviatedHorizontal;

export {GiftCardTileAbbreviatedVertical};

const styles = StyleSheet.create({
  title: {
    color: theme.colour.text.heading.primary,
    fontSize: 16,
    fontWeight: 'bold',
  },
  description: {
    color: theme.colour.text.content.primary,
    fontSize: 14,
  },
});
